import React from "react";
import { Button, Drawer, Modal } from "antd";
import { useSelector } from "react-redux";
import "./style.css";

const getOpenValue = (open, visible) => {
  if (open !== undefined) return open;
  return visible;
};

const ResponsiveModal = ({
  open,
  visible,
  title,
  children,
  footer,
  onOk,
  onCancel,
  okText = "OK",
  cancelText = "Cancel",
  okButtonProps = {},
  cancelButtonProps = {},
  confirmLoading,
  destroyOnClose,
  maskClosable,
  className = "",
  width,
  height,
  bodyStyle,
  afterClose,
  closable,
  zIndex,
  keyboard,
  centered,
  style,
  ...rest
}) => {
  const isPC = useSelector((state) => state.App?.isPC ?? true);
  const isOpen = getOpenValue(open, visible);

  if (isPC) {
    return (
      <Modal
        {...rest}
        open={isOpen}
        visible={visible}
        title={title}
        footer={footer}
        onOk={onOk}
        onCancel={onCancel}
        okText={okText}
        cancelText={cancelText}
        okButtonProps={okButtonProps}
        cancelButtonProps={cancelButtonProps}
        confirmLoading={confirmLoading}
        destroyOnClose={destroyOnClose}
        maskClosable={maskClosable}
        className={className}
        width={width}
        bodyStyle={bodyStyle}
        afterClose={afterClose}
        closable={closable}
        zIndex={zIndex}
        keyboard={keyboard}
        centered={centered}
        style={style}
      >
        {children}
      </Modal>
    );
  }

  const showDefaultFooter = footer === undefined;
  const okLoading = okButtonProps.loading ?? confirmLoading;
  const okDisabled = okButtonProps.disabled;

  return (
    <Drawer
      {...rest}
      open={isOpen}
      title={title}
      placement="bottom"
      height={height || "80vh"}
      onClose={onCancel}
      destroyOnClose={destroyOnClose}
      maskClosable={maskClosable}
      afterOpenChange={(nextOpen) => {
        if (!nextOpen && afterClose) afterClose();
      }}
      closable={closable}
      zIndex={zIndex}
      keyboard={keyboard}
      className={`responsive-modal-drawer ${className || ""}`}
    >
      <div className="responsive-modal-drawer__body" style={bodyStyle}>
        {children}
      </div>
      {footer !== null && (
        <div className="responsive-modal-drawer__footer">
          {showDefaultFooter ? (
            <>
              <Button {...cancelButtonProps} onClick={onCancel}>
                {cancelText}
              </Button>
              <Button type="primary" {...okButtonProps} loading={okLoading} disabled={okDisabled} onClick={onOk}>
                {okText}
              </Button>
            </>
          ) : (
            footer
          )}
        </div>
      )}
    </Drawer>
  );
};

export default ResponsiveModal;
